import { EffectCallback, useEffect } from "react"

// Use effect exactly once after initial render. This documents intent and
// avoids littering the code with ESLint directives for this valid use case.
export const useEffectOnce = (effect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [])
}
